import React, {useRef} from "react";
import cf from "../../../admin_components/common";
import PopUp from "../../base/popup";
import CareerMatchesPopup from "./careerMatchesPopup";

export default function CareerMatches(props) {

    const user = props.user;

    if (!props.completed || !props.isAvailable) {
        return (
            <div className="large-9 medium-12 cell">
                <div className="user__box user__box--full">
                    <h3 className="user__box__title">Career Matches</h3>
                    <div className="user__incomplete">
                        <h3>{props.isAvailable ? 'No matches yet' : 'Access required'}</h3>
                    </div>
                </div>
            </div>
        )
    }

    const careerMatchesPopupRef = useRef(null);

    const displaySalary = (salary) => {
        if (salary === 0) {
            return "N/A"
        }
      let dispSalary = salary > 1000 ? `${salary/1000}k` : salary;
      return `$${dispSalary}`;
    };

    const displayEducation = (educationLevel, studyTime) => {
        if(!educationLevel){
            return 'N/A'
        }
      let level = cf.capitalize(educationLevel.replace('_', ' '));
      return `${level}, ${studyTime}`
    };


    return (
        <div className="large-9 medium-12 cell">
            <div className="user__box user__box--full">
                <h3 className="user__box__title">Career Matches</h3>
                <div className="user__table">
                    <table>
                        <thead>
                        <tr>
                            <th><p>Profession</p></th>
                            <th><p>Match</p></th>
                            <th><p>Ann. Salary</p></th>
                            <th><p>Education</p></th>
                            <th><p>Ann. Growth</p></th>
                            <th colSpan="4"></th>
                        </tr>
                        </thead>
                        <tbody>
                        {props.career_matches.slice(0,10).map((career) => {
                            return (
                                <tr key={career.career.id}>
                                    <td><p className="primary">{career.career.name}</p></td>
                                    <td className="text-right"><p className="primary">{career.score}%</p></td>
                                    <td className="text-right"><p>{displaySalary(career.career.salary_mid)}</p></td>
                                    <td><p>{displayEducation(career.career.education_level, career.career.study_time)}</p></td>
                                    <td className="text-right"><p>{career.career.projected_growth}</p></td>
                                    <td className="text-center"><p><a href={`/careers/${career.career.path}`} target={'_blank'} className="white-off-link">View</a></p>
                                    </td>
                                </tr>
                            )
                        })}
                        <tr>
                            <td><h5 className="white-link mar-top-20" onClick={() => {careerMatchesPopupRef.current.open()}}>View All</h5></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <PopUp ref={careerMatchesPopupRef} parentClass={"popup popup--educators"} >
                <CareerMatchesPopup career_matches={props.career_matches} displaySalary={displaySalary} displayEducation={displayEducation} />
            </PopUp>
        </div>
    )

}